var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 0.398438,
    width: 2.37031,
    height: 2.37031,
    fill: "#323E4F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 0.398438,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 0.398438,
    width: 2.37031,
    height: 2.37031,
    fill: "#3D6E70"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 0.398438,
    width: 2.37031,
    height: 2.37031,
    fill: "#323E4F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    fill: "#CFFF70"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    fill: "#8FDE5D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    fill: "#CFFF70"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    fill: "#585F54"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    fill: "#40444A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    fill: "#585F54"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    fill: "#37423C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    fill: "#37423C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    fill: "#091811"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    fill: "#4E5A51"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    fill: "#2A3A3F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    fill: "#2A3A3F"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    fill: "#091811"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    fill: "#343B4D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    fill: "#091811"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    fill: "#3CA370"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 16.9922,
    width: 2.37031,
    height: 2.37031,
    fill: "#323E4F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44531,
    y: 16.9922,
    width: 2.37031,
    height: 2.37031,
    fill: "#3D6E70"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81641,
    y: 16.9922,
    width: 2.37031,
    height: 2.37031,
    fill: "#3D6E70"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1875,
    y: 16.9922,
    width: 2.37031,
    height: 2.37031,
    fill: "#3D6E70"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 2.76953)",
    fill: "#3D6E70"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 5.13672)",
    fill: "#3D6E70"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 7.51172)",
    fill: "#3CA370"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 9.88281)",
    fill: "#3CA370"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 12.2461)",
    fill: "#3CA370"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 14.6172)",
    fill: "#3D6E70"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9258,
    y: 16.9922,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 16.9258 16.9922)",
    fill: "#272736"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 14.6172)",
    fill: "#272736"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 5.13672)",
    fill: "#3D6E70"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 2.76953)",
    fill: "#272736"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 7.51172)",
    fill: "#3D6E70"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6641,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 21.6641 7.51172)",
    fill: "#272736"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 9.88281)",
    fill: "#3D6E70"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6641,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 21.6641 9.88281)",
    fill: "#272736"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2969,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 19.2969 12.2461)",
    fill: "#3D6E70"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 2.70312,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 2.70312 5.13672)",
    fill: "#8FDE5D"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 2.70312,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 2.70312 7.51172)",
    fill: "#8FDE5D"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 2.70312,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 2.70312 9.88281)",
    fill: "#3CA370"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 2.70312,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 2.70312 12.2461)",
    fill: "#3D6E70"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 2.76953,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 2.76953)",
    fill: "#8FDE5D"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 5.13672,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 5.13672)",
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 7.51172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 7.51172)",
    fill: "#CFFF70"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 9.88281,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 9.88281)",
    fill: "#3CA370"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 12.2461,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 12.2461)",
    fill: "#3CA370"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 14.6172,
    width: 2.37031,
    height: 2.37031,
    transform: "rotate(90 5.07812 14.6172)",
    fill: "#3D6E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointIcon);
export default __webpack_public_path__ + "static/media/point_icon.26bcc71647a32fd0bb97f33e36993d7b.svg";
export { ForwardRef as ReactComponent };